export default __webpack_public_path__ + "static/media/ri_search-line.36fcc72c.svg";